import React from "react";
import { supabase } from '../../supabase';

function VendorProfileModal({ v, onClose, bookingAccepted, sendBookingRequest, hostEvent, bookingRequests, openMessage, setTab, matchPct }) {
  const req = bookingRequests && bookingRequests.find(r => r.vendorId === v.id && (!hostEvent?.eventId || r.eventId === hostEvent.eventId || r.eventName === hostEvent?.eventName));
  const accepted = bookingAccepted || req?.status === 'accepted';
  const cats = v.allCategories || [v.category];
  const photos = v.photoUrls || [];
  const socials = [
    v.website && { icon: '\ud83c\udf10', label: 'Website', url: v.website },
    v.instagram && { icon: '\ud83d\udcf8', label: 'Instagram', url: v.instagram },
    v.facebook && { icon: '\ud83d\udc64', label: 'Facebook', url: v.facebook },
    v.tiktok && { icon: '\ud83c\udfb5', label: 'TikTok', url: v.tiktok },
    v.youtube && { icon: '\u25b6\ufe0f', label: 'YouTube', url: v.youtube },
    v.otherSocial && { icon: '\ud83d\udd17', label: 'Other', url: v.otherSocial },
  ].filter(Boolean);

  const Field = ({label, val}) => val ? (
    <div style={{marginBottom:10}}>
      <div style={{fontSize:11,fontWeight:700,color:'#a89a8a',textTransform:'uppercase',letterSpacing:0.5,marginBottom:2}}>{label}</div>
      <div style={{fontSize:14,color:'#1a1410'}}>{val}</div>
    </div>
  ) : null;

  const BlurredField = ({label, val}) => (
    <div style={{marginBottom:10}}>
      <div style={{fontSize:11,fontWeight:700,color:'#a89a8a',textTransform:'uppercase',letterSpacing:0.5,marginBottom:2}}>{label}</div>
      {accepted && val
        ? <div style={{fontSize:14,color:'#1a1410'}}>{val}</div>
        : <div style={{fontSize:13,color:'#a89a8a',display:'flex',alignItems:'center',gap:6}}>
            <span style={{fontSize:14}}>{'\ud83d\udd12'}</span> Available after booking accepted
          </div>
      }
    </div>
  );

  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
      <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:16,maxWidth:720,width:'100%',maxHeight:'90vh',overflowY:'auto',position:'relative'}}>

        {/* Close button */}
        <button onClick={onClose} style={{position:'sticky',top:12,float:'right',marginRight:12,background:'#1a1410',color:'#e8c97a',border:'none',borderRadius:'50%',width:36,height:36,fontSize:18,cursor:'pointer',zIndex:10,fontFamily:'DM Sans,sans-serif',lineHeight:'36px',textAlign:'center'}}>{'\u2715'}</button>

        {/* Header with photos */}
        {photos.length > 0 ? (
          <div style={{position:'relative',height:220,overflow:'hidden',borderRadius:'16px 16px 0 0'}}>
            <div style={{display:'flex',height:'100%',overflowX:'auto',scrollSnapType:'x mandatory',gap:0}}>
              {photos.map((url,i) => (
                <img key={i} src={url} alt={`${v.name} photo ${i+1}`}
                  style={{minWidth:'100%',height:'100%',objectFit:'cover',scrollSnapAlign:'start'}} />
              ))}
            </div>
            {photos.length > 1 && (
              <div style={{position:'absolute',bottom:10,left:'50%',transform:'translateX(-50%)',display:'flex',gap:6}}>
                {photos.map((_,i) => <div key={i} style={{width:8,height:8,borderRadius:'50%',background:'rgba(255,255,255,0.7)'}} />)}
              </div>
            )}
          </div>
        ) : (
          <div style={{height:120,background:'linear-gradient(135deg,#1a1410,#2d2118)',borderRadius:'16px 16px 0 0',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <span style={{fontSize:64}}>{v.emoji}</span>
          </div>
        )}

        <div style={{padding:'20px clamp(16px, 4vw, 32px) 28px'}}>
          {/* Name + category header */}
          <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:16,flexWrap:'wrap',marginBottom:20}}>
            <div>
              <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:4}}>
                {photos.length > 0 && <span style={{fontSize:28}}>{v.emoji}</span>}
                <h2 style={{fontFamily:'Playfair Display,serif',fontSize:26,color:'#1a1410',margin:0}}>{v.name}</h2>
              </div>
              <div style={{display:'flex',flexWrap:'wrap',gap:6,marginTop:6}}>
                {cats.map(c => <span key={c} style={{background:'#f5f0ea',border:'1px solid #e8ddd0',borderRadius:20,padding:'3px 12px',fontSize:12,color:'#7a6a5a',fontWeight:600}}>{c}</span>)}
              </div>
            </div>
            <div style={{display:'flex',alignItems:'center',gap:6}}>
              {matchPct != null && <div style={{background:'#1a1410',color:'#e8c97a',borderRadius:8,padding:'8px 14px',fontSize:14,fontWeight:700}}>{matchPct}% match</div>}
            </div>
          </div>

          {/* Tags */}
          {(v.tags || []).length > 0 && (
            <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:16}}>
              {(v.tags || []).map(t=><span key={t} className="vendor-tag">{t}</span>)}
              {v.insurance && <span className="vendor-tag" style={{background:'#d4f4e0',color:'#1a6b3a',borderColor:'#b8e8c8'}}>{'\u2713'} Insured</span>}
            </div>
          )}

          {/* Description */}
          {v.description && (
            <div style={{fontSize:15,color:'#4a3a28',lineHeight:1.7,marginBottom:24,padding:'16px 20px',background:'#fdf9f5',borderRadius:10,border:'1px solid #f0e8dc'}}>
              {v.description}
            </div>
          )}

          {/* Two-column details */}
          <div className="modal-2col" style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0 32px',marginBottom:24}}>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:'#1a1410',marginBottom:12,borderBottom:'2px solid #e8c97a',paddingBottom:6}}>About</div>
              <Field label="Location" val={`\ud83d\udccd ${v.homeZip} \u00b7 travels ${v.radius}mi`} />
              {v.contactName && <Field label="Owner / Contact" val={v.contactName} />}
              <Field label="Years Active" val={v.yearsActive} />
              <Field label="Event Types" val={(v.tags || []).length > 0 ? v.tags.join(', ') : null} />
              {(v.subcategories || []).length > 0 && <Field label="Specialties" val={v.subcategories.join(', ')} />}
            </div>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:'#1a1410',marginBottom:12,borderBottom:'2px solid #e8c97a',paddingBottom:6}}>Booth & Logistics</div>
              <Field label="Insurance" val={v.insurance ? '\u2713 Has Certificate of Insurance' : 'Not insured'} />
              {v.hasMinPurchase && <Field label="Minimum Purchase" val={`$${v.minPurchaseAmt}`} />}
              {/* Private event fee hidden */}
              <Field label="Setup Time" val={v.setupTime ? `${v.setupTime} min` : null} />
              <Field label="Table Size" val={v.tableSize} />
              <Field label="Needs Electric" val={v.needsElectric ? 'Yes' : null} />
              <Field label="Response Time" val={v.responseTime} />
              <Field label="Booking Lead Time" val={v.bookingLeadTime} />
            </div>
          </div>

          {/* Service Provider info */}
          {v.isServiceProvider && (
            <div style={{marginBottom:24,background:'#fdf9f5',border:'1px solid #e8ddd0',borderRadius:10,padding:'16px 20px'}}>
              <div style={{fontSize:13,fontWeight:700,color:'#1a1410',marginBottom:12,borderBottom:'2px solid #e8c97a',paddingBottom:6}}>Service Provider</div>
              <Field label="Service" val={v.serviceType} />
              <Field label="Rate" val={v.serviceRateType==='quote' ? 'Quote based' : v.serviceRateType==='range' ? `${v.serviceRateMin} \u2013 ${v.serviceRateMax}` : v.serviceRateMin} />
              <Field label="Min Duration" val={v.minBookingDuration} />
              {v.serviceDescription && <Field label="What's Included" val={v.serviceDescription} />}
            </div>
          )}

          {/* Social links */}
          {socials.length > 0 && (
            <div style={{marginBottom:24}}>
              <div style={{fontSize:13,fontWeight:700,color:'#1a1410',marginBottom:12,borderBottom:'2px solid #e8c97a',paddingBottom:6}}>Links & Social</div>
              <div style={{display:'flex',flexWrap:'wrap',gap:8}}>
                {socials.map(s => (
                  <a key={s.label} href={s.url.startsWith('http') ? s.url : 'https://'+s.url} target="_blank" rel="noopener noreferrer"
                    style={{display:'inline-flex',alignItems:'center',gap:6,background:'#f5f0ea',border:'1px solid #e8ddd0',borderRadius:8,padding:'8px 14px',fontSize:13,fontWeight:600,color:'#1a1410',textDecoration:'none'}}>
                    <span>{s.icon}</span> {s.label}
                  </a>
                ))}
              </div>
            </div>
          )}

          {/* Lookbook */}
          {v.lookbookUrl && (
            <div style={{marginBottom:24}}>
              <a href={v.lookbookUrl} target="_blank" rel="noopener noreferrer"
                style={{display:'inline-flex',alignItems:'center',gap:8,background:'#1a1410',color:'#e8c97a',borderRadius:8,padding:'10px 18px',fontSize:13,fontWeight:700,textDecoration:'none'}}>
                {'\ud83d\udcc4'} View Lookbook / Menu
              </a>
            </div>
          )}

          {/* Contact info — blurred until accepted */}
          <div style={{marginBottom:24,padding:'16px 20px',background:accepted?'#d4f4e0':'#f5f0ea',borderRadius:10,border:'1px solid '+(accepted?'#b8e8c8':'#e8ddd0')}}>
            <div style={{fontSize:13,fontWeight:700,color:accepted?'#1a6b3a':'#1a1410',marginBottom:12}}>
              {accepted ? '\u2705 Contact Info (Booking Accepted)' : '\ud83d\udd12 Contact Info \u2014 Available After Booking Accepted'}
            </div>
            <div className="modal-2col" style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0 24px'}}>
              <BlurredField label="Email" val={v.contactEmail} />
              <BlurredField label="Phone" val={v.contactPhone} />
            </div>
            {!accepted && (
              <div style={{fontSize:12,color:'#a89a8a',marginTop:4}}>
                Invite this vendor to your event and their contact info will be shared once they accept.
              </div>
            )}
          </div>

          {/* Action buttons */}
          <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
            {hostEvent && sendBookingRequest && !req && (
              <button onClick={()=>{sendBookingRequest(v, hostEvent); onClose();}}
                style={{background:'#c8a84b',color:'#1a1410',border:'none',borderRadius:8,padding:'12px 24px',fontSize:14,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
                {'\ud83d\udccb'} Invite to {hostEvent?.eventName || 'My Event'}
              </button>
            )}
            {req && (
              <div style={{
                padding:'10px 16px', borderRadius:8, fontSize:13, fontWeight:600,
                background: req.status==='accepted'?'#d4f4e0':req.status==='declined'?'#fdecea':'#fdf4dc',
                color: req.status==='accepted'?'#1a6b3a':req.status==='declined'?'#8b1a1a':'#7a5a10',
                border: '1px solid '+(req.status==='accepted'?'#b8e8c8':req.status==='declined'?'#f5c6c6':'#ffd966')
              }}>
                {req.status==='pending' && `\u23f3 Invite Pending for ${req.eventName || hostEvent?.eventName || 'Event'}`}
                {req.status==='accepted' && `\u2705 Accepted for ${req.eventName || hostEvent?.eventName || 'Event'}`}
                {req.status==='declined' && `\u274c Declined for ${req.eventName || hostEvent?.eventName || 'Event'}`}
                {req.status==='withdrawn' && '\u21a9 Withdrawn'}
              </div>
            )}
            {req && req.status==='pending' && (
              <button onClick={async()=>{if(!window.confirm('Withdraw this invite?'))return;const{error:delErr}=await supabase.from('booking_requests').delete().eq('id',req.id);if(delErr){console.error('Withdraw invite failed:',delErr);alert('Failed to withdraw invite. Please try again.');return;}onClose();}}
                style={{background:'#fdecea',color:'#8b1a1a',border:'1px solid #f5c6c6',borderRadius:8,padding:'10px 20px',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>Withdraw Invite</button>
            )}
            {openMessage && (
              <button onClick={()=>{openMessage(v); onClose();}}
                style={{background:'#1a1410',color:'#e8c97a',border:'none',borderRadius:8,padding:'12px 24px',fontSize:14,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
                {'\ud83d\udcac'} Message
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default VendorProfileModal;
